// extracted by mini-css-extract-plugin
module.exports = {"referenceFrame":"KagemaneSetupFields_referenceFrame__2ZjS_"};